<p-dialog header="Select Contact" [(visible)]="displayContactSelectionModal" [modal]="true" [responsive]="true" [closable]="false" [style]="{ width: '90vw', 'min-height': '60vh' }"  [baseZIndex]="10000">
    <div class="card">
        <span style="float: right">
            <lion-shared-contacts *ngIf="displayContactSelectionModal" [contactAssociationId]="contactAssociationId" [isDisableAssociation]="true" moduleName="SalesOrder" [object]="accountInfo" (contactInfo)="addContact($event)"></lion-shared-contacts>
        </span>
        <div class="p-grid">
            <div class="p-col-12">
                <p-table [value]="contacts" [(selection)]="selectedContact" dataKey="id" (onRowSelect)="onRowSelectContact($event)" selectionMode="single">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Primary Contact</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-contactInfo>
                        <tr [pSelectableRow]="contactInfo">
                            <td>{{ contactInfo?.isPrimaryContact ? "Yes" : "No" }}</td>
                            <td>{{ contactInfo?.contactName }}</td>
                            <td>
                                {{ contactInfo?.contact && contactInfo?.contact?.contactEmails && contactInfo?.contact?.contactEmails?.length > 0 && contactInfo?.contact?.contactEmails[0].email && contactInfo?.contact?.contactEmails[0].email?.emailAddress ? contactInfo?.contact?.contactEmails[0].email?.emailAddress : "" }}
                            </td>
                            <td>
                                {{ contactInfo?.contact?.contactPhones && contactInfo?.contact?.contactPhones?.length > 0 && contactInfo?.contact?.contactPhones[0].phone && contactInfo?.contact?.contactPhones[0].phone?.number ? contactInfo?.contact?.contactPhones[0].phone?.number : "" }}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="onDialogClose()" label="Cancel" class="p-button-secondary"></button>
    </p-footer>
</p-dialog>
